import { apiClient } from './axios';

import type { MonthlyCostSummary } from '@repo/shared-types';

export const billingApi = {
  getMonthlyCost: async (
    month?: string,
    day?: number,
    refresh?: boolean,
  ): Promise<MonthlyCostSummary> => {
    const response = await apiClient.get<MonthlyCostSummary>('/billing/monthly-cost', {
      params: {
        month,
        day: day || undefined,
        refresh: refresh ? 'true' : undefined,
      },
    });
    return response.data;
  },
};
